// eslint-disable-next-line import/prefer-default-export
export const AUTHORIZED_BROWSERS = ['FIREFOX', 'CHROME', 'SAFARI'];
